import { AllPurposeLink } from '@components/all-purpose-link'
import { BodyText, DetailText } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
import { AnimatePresence, motion } from 'motion/react'
import React from 'react'
import { ArtistGridItemProps } from '../types'
import { gridItemTransition } from '@components/grid'

export const ArtistImageGridItem = ({ item }: { item: ArtistGridItemProps }): React.ReactElement => {
  const [hovered, setHovered] = React.useState(false)

  return (
    <AllPurposeLink href={item.artist.url} onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      <div className="gap-y-xs flex flex-col items-center text-center">
        <div className="relative aspect-square h-auto w-full">
          <AnimatePresence>
            <motion.div
              className="absolute inset-0"
              key={`${item.artist.name}${hovered ? '-featured-token' : '-hovered'}`}
              animate={{ opacity: 1 }}
              initial={{ opacity: 0 }}
              exit={{ opacity: 0 }}
              transition={gridItemTransition}
            >
              <ImageWithCustomLoader
                src={(hovered ? item.artist.featuredTokenUrl : item.artist.avatarUrl) || ''}
                alt={`${item.artist.name} profile picture card`}
                fill
                className={hovered ? 'p-md object-contain drop-shadow-[3px_3px_6px_rgba(0,0,0,0.20)]' : 'object-cover'}
                sizes="33vw"
              />
            </motion.div>
          </AnimatePresence>
        </div>
        <div className="gap-y-2xs flex flex-col items-center">
          <BodyText>{item.artist.name}</BodyText>
          <DetailText className="text-on-surface-variant font-medium">{item.artist.subtext?.toUpperCase()}</DetailText>
        </div>
      </div>
    </AllPurposeLink>
  )
}
